/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetTracePromotionJobPathParams = NonNullable<operations['getTracePromotionJob']['parameters']['path']>;

export interface Input extends GetTracePromotionJobPathParams {
  apiVersion?: string;
}

export async function getTracePromotionJob(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/environments/{envKey}/datasets/{datasetId}/jobs/{jobId}', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
